var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122.838,
    height: 122.838,
    rx: 61.4189,
    fill: "#FFA48F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5037 37.8238L50.8571 73.1908L41.1324 62.8008C39.341 61.1118 36.526 61.0094 34.4787 62.4425C32.4826 63.9268 31.9196 66.5371 33.148 68.6356L44.664 87.3684C45.79 89.1086 47.7349 90.1834 49.9358 90.1834C52.0343 90.1834 54.0304 89.1086 55.1564 87.3684C56.999 84.9628 92.1613 43.0444 92.1613 43.0444C96.7677 38.3356 91.1889 34.1898 87.5037 37.7726V37.8238Z",
    fill: "#020246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalIcon);
export default __webpack_public_path__ + "static/media/approval_icon.74978f86db4fbdc531d7268553952750.svg";
export { ForwardRef as ReactComponent };